import { useId } from "react";
import styles from "./QuoatesCard.module.scss";

const STAR_PATH =
  "M6.84316 0.316017C7.00987 -0.105427 7.60634 -0.105428 7.77305 0.316016L9.41899 4.47699C9.48885 4.65358 9.65271 4.77536 9.84194 4.79131L14.1575 5.15509C14.5938 5.19187 14.7754 5.73184 14.4501 6.02484L11.126 9.0189C10.9914 9.14006 10.9329 9.32448 10.973 9.50104L11.982 13.949C12.0811 14.3854 11.6008 14.7222 11.2242 14.4803L7.5783 12.1388C7.41368 12.0331 7.20253 12.0331 7.03791 12.1388L3.39197 14.4803C3.01541 14.7222 2.53516 14.3854 2.63417 13.949L3.64324 9.50104C3.68329 9.32448 3.62478 9.14006 3.49025 9.0189L0.166073 6.02484C-0.159232 5.73184 0.0224423 5.19187 0.458699 5.15509L4.77427 4.79131C4.9635 4.77536 5.12736 4.65358 5.19722 4.47699L6.84316 0.316017Z";

export const StarIcon = ({
  fillPercentage,
  color = "currentColor", // Define un color predeterminado o usa el color pasado como prop
}: {
  fillPercentage: number;
  color?: string;
}) => {
  const id = useId();
  const gradientId = `partial-fill-${id}`;

  return (
    <svg
      viewBox="-1 -1 17 17"
      className={styles.star}
      aria-hidden="true"
      width="16"
      height="16"
    >
      <defs>
        <linearGradient id={gradientId}>
          <stop offset={`${fillPercentage}%`} stopColor={color} />
          <stop offset={`${fillPercentage}%`} stopColor="transparent" />
        </linearGradient>
      </defs>
      <path d={STAR_PATH} fill={`url(#${gradientId})`} />
      <path d={STAR_PATH} fill="none" stroke={color} />
    </svg>
  );
};
